import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar.tsx";
import Navbar from "./Navbar.tsx";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [headerClass, setHeaderClass] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
    return () => window.removeEventListener("scroll", scrollNavigation, true);
  }, []);

  function scrollNavigation() {
    let scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  const toggleClass = (el, className) => {
    el.classList.toggle(className);
  };

  const handleHorizontalLayout = (body) => {
    toggleClass(body, "menu");
  };

  const handleVerticalLayout = (html, body, width) => {
    const isTablet = width > 767 && width < 1025;
    const isDesktop = width > 1025;
    const isMobile = width <= 767;

    if (isMobile) {
      body.classList.add("vertical-sidebar-enable");
      html.dataset.sidebarSize = "lg";
      return;
    }

    body.classList.remove("vertical-sidebar-enable");

    if (isTablet) {
      html.dataset.sidebarSize =
        html.dataset.sidebarSize === "sm" ? "" : "sm";
    } else if (isDesktop) {
      html.dataset.sidebarSize =
        html.dataset.sidebarSize ? "sm" : "lg";
    }
  };

  const handleTwoColumnLayout = (body) => {
    toggleClass(body, "twocolumn-panel");
  };

  const toggleSidebar = () => {
    const html = document.documentElement;
    const body = document.body;
    const width = html.clientWidth;

    html.dataset.sidebarVisibility = "show";

    if (width > 767) {
      document.querySelector(".hamburger-icon")?.classList.toggle("open");
    }

    const layout = html.dataset.layout;

    if (layout === "horizontal") {
      handleHorizontalLayout(body);
    }

    if (
      html.dataset.sidebarVisibility === "show" &&
      (layout === "vertical" || layout === "semibox")
    ) {
      handleVerticalLayout(html, body, width);
    }

    if (layout === "twocolumn") {
      handleTwoColumnLayout(body);
    }
  };

  return (
    // <div className="flex min-h-screen overflow-x-hidden" id="layout-wrapper">
    <div id="layout-wrapper">
      <Sidebar isOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

      <div
        // className={`flex-1 transition-all duration-300 overflow-x-hidden main-content ${
        //   isSidebarOpen ? "ml-[230px]" : "ml-[70px]"
        // }`}
        className="main-content"
      >
        <Navbar 
          onMenuClick={toggleSidebar} 
          isSidebarOpen={isSidebarOpen} 
          headerClass={headerClass}
        />

        {/* <div className="w-full px-4 lg:px-6 overflow-x-hidden"> */}
          {/* Add padding-top to account for navbar (65px) + breadcrumb height (~50px) */}
          <main className="page-content">
            {/* <div className="container fluid bg-white rounded-lg min-h-[calc(100vh-8rem)] max-h-[calc(100vh-8rem)] overflow-y-auto overflow-x-hidden w-full"> */}
              <div className="container-fluid">
              {children}
            </div>
          </main>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Layout;